import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const findAppsRoute: InvariantJiraRoute = {
	name: 'marketplace-index',
	path: '/jira/marketplace',
};
